/**
 * Where an ICS2 error belongs in the declaration, expressed the way the UI numbers things rather
 * than the way the wire does.
 *
 * Customs points at an error with a `messageElementPath` whose array indices are 0-based offsets
 * (`goodsItem[0]`), but the item's real identity is its `goodsItemNumber`, which ICS2 rules R3016
 * and R3017 require to start at 1. Every other screen is 1-based too ("House Consignment 1 |
 * Item 1"), so the offsets are converted once, at the boundary. The raw path stays on the error
 * details pane so the mapping remains auditable.
 *
 * Index 0 is kept for errors that belong to a level itself rather than to any goods item - the
 * same meaning `EMPTY_LEVEL_INDEX` already carries in the pre-submission parsers.
 */
export type Ics2ErrorLevel = 'master' | 'masterItem' | 'houseConsignment' | 'houseItem';

export interface Ics2ErrorLocation {
    level: Ics2ErrorLevel;
    houseConsignmentIndex?: number;
    itemIndex?: number;
    fieldPath?: string;
}

/** An error that belongs to a level itself rather than to one of its goods items. */
export const ICS2_LEVEL_INDEX = 0;
